<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3518_8750)">
<mask id="mask0_3518_8750" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="40">
<path d="M40.0001 20C40.0083 22.8687 39.3906 25.7046 38.1901 28.31C37.69 29.4089 37.0909 30.4599 36.4001 31.45C34.3259 34.4291 31.4764 36.784 28.1601 38.26C25.5942 39.4121 22.8127 40.0052 20.0001 40C15.2893 40.0045 10.7293 38.3392 7.13007 35.3L6.91007 35.11C5.33646 33.7572 3.98648 32.1642 2.91007 30.39C0.998137 27.2623 -0.00918285 23.6658 6.30812e-05 20C6.30812e-05 8.96 8.96006 0 20.0001 0C31.0401 0 40.0001 8.96 40.0001 20Z" fill="white"/>
</mask>
<g mask="url(#mask0_3518_8750)">
<path d="M40 0H0V40H40V0Z" fill="#D1DAEB"/>
<path d="M11.98 7.96992V39.9999H0V7.91992L11.98 7.96992Z" fill="#4E7091"/>
<path d="M2.58002 24.75H0V28.75H2.58002V24.75Z" fill="#89A9D6"/>
<path d="M2.58002 17.84H0V21.84H2.58002V17.84Z" fill="#89A9D6"/>
<path d="M2.58002 10.8101H0V14.8101H2.58002V10.8101Z" fill="#89A9D6"/>
<path d="M2.58002 32.48H0V36.48H2.58002V32.48Z" fill="#89A9D6"/>
<path d="M23.86 15.5601H11.98V29.3601H23.86V15.5601Z" fill="#BE151D"/>
<path d="M23.82 29.3601V40.0001H11.96V29.3301H11.98L23.82 29.3601Z" fill="#F8B8BA"/>
<path d="M23.86 29.3599H15.76V32.7899H23.86V29.3599Z" fill="#4E7091"/>
<path d="M16 18H14V27H16V18Z" fill="#FDDCDD"/>
<path d="M22 18H20V27H22V18Z" fill="#FDDCDD"/>
<path d="M29.3901 29.3601H23.8601V15.5601L26.6301 3.81006L29.3901 15.5601V29.3601Z" fill="#002343"/>
<path d="M34.2299 29.3599H29.3899V39.9999H34.2299V29.3599Z" fill="#753C55"/>
<path d="M29.3901 29.3599H23.8601V32.7899H29.3901V29.3599Z" fill="#BE151D"/>
<path d="M29.3901 32.78V40H23.8601V32.82L28.0101 32.79L29.3901 32.78Z" fill="#ED1F27"/>
<path d="M26.63 20.64C26.8444 20.6414 27.057 20.6001 27.2554 20.5187C27.4537 20.4372 27.634 20.3172 27.7856 20.1656C27.9372 20.014 28.0572 19.8337 28.1387 19.6354C28.2201 19.437 28.2613 19.2245 28.26 19.01C28.2613 18.7956 28.2201 18.5831 28.1387 18.3847C28.0572 18.1863 27.9372 18.0061 27.7856 17.8545C27.634 17.7029 27.4537 17.5828 27.2554 17.5014C27.057 17.42 26.8444 17.3787 26.63 17.38C26.1977 17.38 25.7831 17.5518 25.4774 17.8575C25.1717 18.1631 25 18.5777 25 19.01C25 19.4423 25.1717 19.8569 25.4774 20.1626C25.7831 20.4683 26.1977 20.64 26.63 20.64Z" fill="white"/>
<path d="M29.3899 29.3601L34.2299 24.8101V29.3601H29.3899Z" fill="#EB737A"/>
<path d="M8.81006 10.8101H5.81006V14.8101H8.81006V10.8101Z" fill="#89A9D6"/>
<path d="M8.81006 17.78H5.81006V21.78H8.81006V17.78Z" fill="#89A9D6"/>
<path d="M8.81006 24.75H5.81006V28.75H8.81006V24.75Z" fill="#89A9D6"/>
<path d="M8.81006 32.48H5.81006V36.48H8.81006V32.48Z" fill="#89A9D6"/>
</g>
</g>
<defs>
<clipPath id="clip0_3518_8750">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>
